import React, {
  useState, useEffect,
}                               from "react";
import { useDispatch, useSelector }          from "react-redux";

import {
  DIALOG_USER_STATE, NLU_TYPES,
}                               from '../../../core/constants';

import { Box, Grid, Table, TableBody, TableCell, TableRow, Typography }                 from "@material-ui/core";
import List                     from "@material-ui/core/List";
import ListItem                 from "@material-ui/core/ListItem";
import ListItemText             from "@material-ui/core/ListItemText";
import GridList                 from "@material-ui/core/GridList";
import GridListTile             from "@material-ui/core/GridListTile";
import TextField                from "@material-ui/core/TextField";
import Autocomplete             from "@material-ui/lab/Autocomplete";
import Button                   from "@material-ui/core/Button";

import { makeStyles }           from "@material-ui/core/styles";

import NumberField              from "../../components/material-ui/NumberField";
import ConfirmDialog            from "../../components/confirmDialog";

import {
  getData,
  postData,
  putData,
}                               from "../../../core/fetchService";
import {
  useTranslation,
  cmpPossibleNumbers,
  mapObject,
  filterObject,
  filterOutKeys,
  findEntry,
  EffectManager,
  getRunConfigOption,
}                               from "../../../core/utils";
import {
  getConfig,
  fetchBackends,
  getBackends,
}                               from "../../../features/settings";

// import Autocomplete from "../../components/material-ui/Autocomplete";

const EMPTY_SIM_CONFIG_DETAILS = { models: {} };

const useStyles = makeStyles(theme => ({
  list: {
    width: '100%',
    height: 360,
    overflow: 'auto',
  },
  selected: {
    // '!important' to override styles coming with 'button' property
    backgroundColor: theme.palette.action.hover +' !important',
  },
  gridList: {
    /* width: '100%', */
    /* overflow: "hidden", */
  },
  textField: {
    marginTop: 8,
    marginBottom: 8,
  },
  dialogContent: {
    padding: '0 10px',
  },
  fieldset: { // from editModelDialog.js
    height: 360,
    overflow: 'auto',
    padding: '5px 25px',
    borderRadius: 5,
    borderWidth: 1,
  },
  legend: {
    marginLeft: '-10px',
    color: "#aaa",
  },
}));


export default function SettingsDialog({ onClose }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const backends = useSelector(getBackends);
  const classes = useStyles();

  const [settings, setSettings] = useState();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchBackends());
      getData('/api/settings', dispatch, data => setSettings(data.settings[0] || {}));
    }

    fetchData();    
  }, []);

  const handleClose = async (state) => {
    if (state == DIALOG_USER_STATE.AGREE) {
      const tempSettings = {...settings};
      const url = '/api/settings'+ (settings._id ? '/'+ settings._id : '');
      const saveData = settings._id ? putData : postData;
      await saveData(url, { settings }, dispatch);
    }
    onClose();
  };

  return settings ? (
    <ConfirmDialog
      title={t("common.global_settings")}
      content={
        <SettingsMenu
          backends={backends}
          typeOfInput="autocomplete"
          settings={settings}
          setSettings={setSettings}
        />
      }
      closeModal={handleClose}
      fullWidth
      maxWidth="md"
      contentProps={{
        className: classes.dialogContent,
      }}
    />
  ) : null;
}

export function SettingsMenu({ settings, setSettings, style = {}, typeOfInput, backends }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const config = useSelector(getConfig);

  const { train_url } = settings.nluConfig || {}; // TODO: remove after EOL
  const { training } = settings.nluConfig || {};
  const be_training = backends?.find(b => b._id == training);

  const [menuItemKey, setMenuItemKey] = useState('backends');
  const [nluConfigServer, setNLUConfigServer] = useState(be_training?.url || train_url);

  useEffect(() => {
    if (menuItemKey == 'similarity')
      setNLUConfigServer(be_training?.url || train_url);
  }, [menuItemKey]);

  const MENU = {
    backends: {
      id: 'nlu',
      fields: ['train_url', 'deploy_url'],
      props: {
        typeOfInput,
        backends,
        fieldDescr: {
          train_url: { type: 'nb_server', onChange: setNLUConfigServer, info: true },
          deploy_url: { type: 'nb_runtime', info: true },
        },
      },
      component: BackendSettings,
    },
    similarity: {
      id: 'similarity',
      component: SimilaritySettings,
      props: {
        typeOfInput: 'textField',
        server: nluConfigServer,
        menuItemKey,
      },
    },
    import_from_dc: {
      id: 'composer',
      show_if: Boolean(config.enableImportFromDC),
      fields: ['url', 'applicationId', ...(Boolean(config.oauthServer) ? [] : ['token'])],
      props: {
        typeOfInput: 'textField',
      },
      fieldset_label: t('settings.fieldset_import_from_dc'),
      component: ImportFromDCSettings,
    },
  };

  const MENU_PROPS = mapObject(MENU, (m,k) => {
    const id = m.id || k;
    const name = id +'Config';
    return {
      id,
      fields: m.fields,
      settings: settings[name],
      setSettings: (field_name, opts = {}) => (data, val) => {
        let value_obj;

        if (opts.is_direct) {
          value_obj = data;
        } else if (opts.get_new_name) {
          value_obj = { [opts.get_new_name(field_name)]: val._id };
        } else {
          value_obj = { [field_name]: data.target.value };
        }

        const other = (name == 'nluConfig' && field_name == 'train_url')
          ? { similarityConfig: { ...settings.similarityConfig, model: null, partition: null } }
          : {};
        setSettings({ ...settings, [name]: { ...settings[name], ...value_obj }, ...other });
      },
      ...m.props,
    };
  });

  return SettingsMenuTabs(MENU, MENU_PROPS, { menuItemKey, setMenuItemKey, style });
}

export function SettingsMenuTabs(MENU, MENU_PROPS, { menuItemKey, setMenuItemKey, style = {} }) {
  const _MENU_KEYS = Object.keys(MENU).filter(k => MENU[k].show_if !== false);
  const MENU_KEYS = _MENU_KEYS.filter(k => !MENU[k].is_group || _MENU_KEYS.find(j => MENU[j].group == k));

  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container wrap='nowrap' style={{ overflow: 'auto', ...style }}>
      <Grid item xs={3} sm={3} style={{ padding: 0, borderRight: 'solid 1px #eee' }}>
        <List className={classes.list}>
          {MENU_KEYS.map((k,i) => (
            <ListItem key={k} button
              className={k == menuItemKey ? classes.selected : ''}
              disabled={MENU[k].is_group}
              onClick={() => setMenuItemKey(k)}
            >
              <ListItemText
                primary={MENU[k].item_label || t('settings.menu_'+ k)}
                style={MENU[k].group ? { margin: 0, paddingLeft: 20 } : {}}
              />
            </ListItem>
          ))}
        </List>
      </Grid>
      <Grid item xs={9} sm={9} style={{ padding: 10, paddingRight: 0 }}>
        {MENU_KEYS.map(k => {
          const MenuItem = MENU[k].component;
          return MENU[k].is_group || k != menuItemKey ? null : (
            <fieldset key={k} className={classes.fieldset}>
              <legend className={classes.legend}>{MENU[k].fieldset_label || t('settings.menu_'+ k)}</legend>
              <MenuItem {...MENU_PROPS[k]}/>
            </fieldset>
          )})}
      </Grid>
    </Grid>
  );
}

export function BackendSettings({
  id, fields, settings = {}, setSettings, fieldDescr = {}, typeOfInput, backends,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();

  const isLoading = !backends;

  /* TODO: remove after EOL - these two params are needed for transition to the new BE referencing
   *       fields in models and datasets, which have different location (scope, in models), and names
   *       (in datasets)
   *           fieldScopes: this is for dealing with new 'nluConfig' scope in Model schema
   *           fieldNames:  enables working with DataSet sim/genConfig' field 'nlu_backend'
   */
  const fieldScopes = mapObject(fieldDescr, d => d.scope);
  const fieldNames =  mapObject(fieldDescr, d => d.new_name);
  const apply_scope = (name, s) => fieldScopes[name]?.(s) ?? s;

  const get_be_type = name => ({ train_url: "training", deploy_url: "runtime" })[name];
  const get_new_name = name => fieldNames[name] || get_be_type(name);

  const backendOptions = name => [
    ...(backends ?? []).filter(b => b.type == get_be_type(name)),
    ...(settings[name] && !(backends?.filter(b => b.type == get_be_type(name))
                            .some(b => b.url == settings[name]?.trim()))
        ? [{ url: settings[name], OLD_URL: true, }]
        : []),
  ];

  const _get_ac_value = name => backendOptions(name).find(b => {
    const new_name = get_new_name(name);
    return apply_scope(name, settings)[new_name]
      ? b._id == apply_scope(name, settings)[new_name]
      : b.url == settings[name]?.trim();
  }) || null;

  const get_ac_value = isLoading ? name => ({ name: "loading..." }) : _get_ac_value;

  const [savedValue, setSavedValue] = useState();

  const onPressEnter = action => event => {
    if (event.key == 'Enter')
      action(event);
  };

  const handleFocus = event => setSavedValue(event.target.value);
  const handleChange = onChange => async event => {
    const value = event.target.value;
    if (value && value != savedValue) {
      onChange(value);
      setSavedValue(value);
    }
  };

  const showTable = (info, error) => (
    <Table style={{ width: "100%" }}>
      <TableBody>
        {!error ? (
        Object.entries(info).map(([k, v]) => (
            <TableRow key={k}>
              <TableCell style={{ borderBottom: "none" }}>
                {t(`settings.${k}`)}:
              </TableCell>
              <TableCell style={{ borderBottom: "none" }}>{v}</TableCell>
            </TableRow>
        ))
        ) : (
          <TableRow>
            <TableCell
              width="15%"
              style={{ color: "red", borderBottom: "none" }}
            >
              {t("common.error")}:{" "}
            </TableCell>
            <TableCell style={{ borderBottom: "none" }}>{error}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );

  const getNBServerInfo = field_name => async setInfo => {
    const url = typeOfInput == "autocomplete" ? _get_ac_value(field_name)?.url : settings[field_name];
    if (!url)
      return setInfo(showTable(undefined, 'internal FE error: expected server url'));

    const data = await getData('/api/settings/server_info?server='+ url, dispatch, undefined, { isShowError: false });
    if (data.error)
      return setInfo(showTable(undefined, t('settings.error_server_info', data.error)));
    const d = data.server_info;
    if (!d)
      return setInfo(showTable(undefined, 'internal FE error: expected server_info field in response'));

    const v = d.app_config?.e2e_version;
    const info = {
      version: d.version + (d.app_config ? '' : ' <!> incompatible with this NLU Suite version'),
      start_time: new Date(d.start_time).toLocaleString(),
      mp_enabled: d.app_config?.multiprocessing ? t('common.yes') : t('common.no'),
      asr_enabled: t(v ? 'common.yes' : 'common.no') + (v ? '! // e2efw v'+ v : ''),
      num_running_tasks: d.num_tasks?.running || 0,
      url
    };
    setInfo(showTable(info));
  };

  const getRuntimeServerStatus = field_name => async setInfo => {
    let url = settings[field_name];
    const runtime = apply_scope(field_name, settings).runtime;

    // TODO: remove after 'deploy_url' EOL
    if (runtime && field_name == "deploy_url") {
      const b = backends.find(b => b._id == runtime);
      if (b) {
        url = b.adminUrl;
        if (!url)
          return setInfo(showTable(undefined, t('settings.error_no_admin_url', t('backends.admin_url'), b.name)));
      }
    }

    if (!url)
      return setInfo(showTable(undefined, 'internal FE error: expected server url'));

    const query = new URLSearchParams();
    query.append('server', url);
    query.append('type', 'NLU_NB');
    query.append('is_mgmt', true); // TODO: remove
    const data = await getData(`/api/runtime/list_models?${query}`, dispatch, undefined, { isShowError: false });
    if (data.error)
      return setInfo(showTable(undefined, t('settings.error_server_info', data.error)));
    if (!Array.isArray(data))
      return setInfo(showTable(undefined, 'internal FE error: expected array in response'));

    const info = {
      num_models: data.length,
      url,
    };
    setInfo(showTable(info));
  };

  const getServerInfo = (field_name, type) => {
    const info = {
      nb_server: getNBServerInfo(field_name),
      nb_runtime: getRuntimeServerStatus(field_name),
    };
    if (!info[type])
      return () => alert(`Error: no getServerInfo func for type '${type}'`);
    return info[type];
  };

  const error = name => get_ac_value(name)?.OLD_URL ? t('settings.error_old_url') : false;

  const fieldComponents = typeOfInput == 'autocomplete'
    ? mapObject(fieldDescr, (field, name) => (fieldClass, serverInfo, setServerInfo) =>
      <Autocomplete
        id={id}
        disableClearable
        style={{ flexGrow: 1 }}
        className={fieldClass(name, "field")}
        fontSize = '16px'
        required
        disabled={isLoading}
        size="small"
        options={backendOptions(name)}
        label={t(`settings.${id}_${name}`)}
        onChange={(e,v) => { void field.onChange?.(v); setSettings(name, { get_new_name })(e,v) }}
        variant="outlined"
        getOptionLabel={o => !o.OLD_URL ? o.name : o.url}
        filterOptions={options => options.filter(o => !o.OLD_URL)}
        value={get_ac_value(name)}
        getOptionSelected={(option, value) => option._id == value._id}
        renderOption={(option) => (
          <>
            <Box display="flex" justifyContent="space-between" alignItems='center' width="100%">
              <Typography>{option.name}</Typography>
              <Typography 
                variant="body2" 
                color="textSecondary" 
                sx={{ fontSize: '0.3rem' }}
              >
                {option.url}
              </Typography>
            </Box>
          </>
        )
        }
        renderInput={(params) => (
          <TextField
            className={classes.dialogFields}
            required
            {...params}
            variant="outlined"
            label={t(`settings.${id}_${name}`)}
            error={Boolean(error(name))}
            helperText={error(name)}
          />
        )}
        {...field.props}
      />
    ) : undefined;

  /* insert url from new field (training/runtime) into the old one (nlu_train_url, f.e.)
   * TODO: remove after EOL
   */
  const _fixed_settings = typeOfInput == 'autocomplete' 
    ? { ...settings, ...mapObject(fieldDescr, (_, name) => _get_ac_value(name) || settings[name]) }
    : settings;

  return (
    <FieldSetSettings
      {...{ id, fields, settings: _fixed_settings, setSettings }}
      fieldComponents={fieldComponents}
      fieldProps={mapObject(fieldDescr, d => ({
        ...(d.onChange && typeOfInput == 'textField' ? {
          onFocus: handleFocus,
          onBlur: handleChange(d.onChange),
          onKeyDown: onPressEnter(handleChange(d.onChange)),
        } : {}),
        ...d.props,
      }))}
      fieldClasses={mapObject(fieldDescr, d => ({ field: d.classes, info: d.classes_info }))}
      fieldButtons={mapObject(filterObject(fieldDescr, v => v.info), (field, name)  => ({
        getServerInfo: getServerInfo(name, field.type),
        ...(typeOfInput == 'autocomplete' && isLoading ? { disabled: () => true } : {}),
      }))}
    />
  );
}

function FieldSetSettings(props) {
  const {
    id,
    fields,
    settings = {},
    setSettings,
    fieldComponents = {},
    fieldProps = {},
    fieldClasses = {},
    fieldButtons = {},
  } = props;
  
  const { t } = useTranslation();                                                   
  const classes = useStyles();
  const fieldClass = (name, kind) => [classes.textField, ...[fieldClasses[name]?.[kind] || []].flat()].join(' ');

  const [serverInfo, setServerInfo] = useState();

  return (
    <div className={classes.gridList} style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
      {serverInfo && <ConfirmDialog
        title={t("settings.server_info_title")}
        content={serverInfo}
        showBtnNameAgree={false}
        btnNameDisagree={t('common.ok')}
        closeModal={() => setServerInfo()}
        fullWidth
        maxWidth='xs'
      />}
      {fields.map((name) => (
        <div
          key={name}
          style={{
            display: "flex",
            flexDirection: "row",
            height: "auto",
            margin: 0,
            alignItems: 'flex-start',
          }}
        >
          {fieldComponents[name]?.(fieldClass, serverInfo, setServerInfo) || (
            <TextField
              label={t(`settings.${id}_${name}`)}
              size="small"
              variant="outlined"
              fullWidth
              className={fieldClass(name, "field")}
              value={settings[name] ?? ""}
              onChange={setSettings(name)}
              {...fieldProps[name]}
            />
          )}
          {fieldButtons[name] && (
            <Button
              style={{ marginLeft: 10, width: 114, minWidth: 114 /* in case AC field grows too much */, height: 40 }}
              className={fieldClass(name, 'info')}
              disabled={!String(settings[name] || '').trim() || fieldButtons[name].disabled?.(settings[name])}
              variant="outlined"
              onClick={() => fieldButtons[name].getServerInfo(setServerInfo)}
            >
              {t("settings.server_info")}
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}

export function SelectModel({
  menuItemKey,
  settings = {},
  onChange,
  modelInfo,
  setModelInfo,
  EMPTY_MODEL_INFO,
  url,
  getModelInfoFromResponse,
  getOptions,
  getOptionLabel = m => m,
  getValue,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const efm = new EffectManager();

  const [isLoading, setIsLoading] = useState(false);

  const updateModelInfo = async () => {
    setIsLoading(true);
    let d = EMPTY_MODEL_INFO;
    setModelInfo(d); // in case of request error this resets modelInfo
    if (!url)
      return;
    const x = await getData(url, dispatch, data => {
      d = getModelInfoFromResponse(data) || EMPTY_MODEL_INFO;
    }, {
      request_manager: efm,
    });
    if (efm.cancelled)
      return;
    setModelInfo(d);
    setIsLoading(false)
  };

  useEffect(() => {
    const x = async () => updateModelInfo();
    ["item_from_llm", "item_similarity", "item_auto"].includes(menuItemKey) && x();
    return efm.cancel;
  }, [url, menuItemKey]);

  return (
    <Autocomplete
      size="small"
      fullWidth
      disabled={isLoading}
      className={classes.textField}
      options={getOptions(modelInfo)}
      getOptionLabel={m => modelInfo ? getOptionLabel(m, modelInfo) : t('common.loading')}
      value={getValue(modelInfo)}
      onChange={onChange}
      renderInput={params =>
        <TextField {...params} variant="outlined" label={t("projects.model")}/>
      }
    />
  );
}

export function SimilaritySettings({ settings = {}, setSettings, server, menuItemKey }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();

  const [simConfDetails, setSimConfDetails] = useState();

  const onChange = name => (event, value) => {
    const other = name == 'model' ? { partition: null } : {};
    setSettings(name, { is_direct: true })({ [name]: value, ...other });
  };

  return (
    <GridList className={classes.gridList} cols={1}>
      <GridListTile cols={1} style={{ height: "auto" }}>
        <SelectModel
          menuItemKey={menuItemKey}
          settings={settings}
          onChange={onChange('model')}
          modelInfo={simConfDetails}
          setModelInfo={setSimConfDetails}
          EMPTY_MODEL_INFO={EMPTY_SIM_CONFIG_DETAILS}
          url={server && `/api/settings/similarity_config_details?server=${server}`}
          getModelInfoFromResponse={data => data.similarity_config_details}
          getOptions={modelInfo => Object.keys(modelInfo?.models || {}).filter(m => modelInfo.models[m].type != 'rasa')}
          getOptionLabel={(m, modelInfo) => {
            const cps = modelInfo.models[m]?.cluster_partitions;
            return cps && cps.length ? m +` _ _ _ _ _ [${t("projects.cluster_partitions")}: `
              + cps.join(', ') +']' : m;
          }}
          getValue={modelInfo => modelInfo?.models[settings?.model] && settings?.model || null}
        />
      </GridListTile>
      <GridListTile cols={1} style={{ height: "auto" }}>
        <Autocomplete
          size="small"
          fullWidth
          options={
            (settings?.model && simConfDetails
              && simConfDetails.models[settings?.model]?.cluster_partitions || [])
              .sort(cmpPossibleNumbers)
          }
          className={classes.textField}
          value={String(settings?.partition ?? '') || null}
          renderInput={params =>
            <TextField {...params} variant="outlined" label={t("projects.cluster_partitions")}/>
          }
          onChange={onChange("partition")}
        />
      </GridListTile>
      <GridListTile cols={1} style={{ height: "auto" }}>
        <NumberField
          label={t("settings.sim_limit")}
          className={classes.textField}
          value={settings?.max || ''}
          inputProps={{ min: 0 }}
          onChange={setSettings("max")}
        />
      </GridListTile>
      <GridListTile cols={1} style={{ height: "auto" }}>
        <NumberField
          label={t("settings.sim_threshold")}
          className={classes.textField}
          value={settings?.threshold ?? ''}
          inputProps={{ min: 0, max: 1, step: '.1' }}
          onChange={setSettings("threshold")}
        />
      </GridListTile>
    </GridList>
  );
}

export const ImportFromDCSettings = FieldSetSettings;
export const ImportFromSASettings = FieldSetSettings;

